import { SupplyMonitorCityResp, SupplyMonitorDistrictResp, SupplyMonitorProvinceResp, SupplyMonitorSubdistrictResp } from "domain/payload/response/clientTransmora/storeDirectorySupplyMonitor/SupplyMonitorAreaResp";
import { SupplyMonitorPointInterestResp } from "domain/payload/response/clientTransmora/storeDirectorySupplyMonitor/SupplyMonitorPointInterestResp";
import { SupplyMonitorRoadTypeResp } from "domain/payload/response/clientTransmora/storeDirectorySupplyMonitor/SupplyMonitorRoadTypeResp";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import StoreDirectorySupplyMonitorService from "service/ClientTransmoraService/StoreDirectorySupplyMonitorService";

interface ModalFilterStoreDirectoryProps {
  onClose: () => void;
  onApply: (filters: {
    startDate?: string | null;
    endDate?: string | null;
    provinceId?: string[];
    cityId?: string[];
    districtId?: string[];
    subdistrictId?: string[];
    pointInterest?: string[];
    roadType?: string[];
  }) => void;
  activeFilters?: {
    startDate?: string | null;
    endDate?: string | null;
    provinceId?: string[];
    cityId?: string[];
    districtId?: string[];
    subdistrictId?: string[];
    pointInterest?: string[];
    roadType?: string[];
  };
}

const ModalFilterSupplyMonitor: React.FC<ModalFilterStoreDirectoryProps> = ({
  onClose,
  onApply,
  activeFilters = {},
}) => {
  const { profile } = useSelector((state: any) => state.auth);
  const SupplyMonitorService = StoreDirectorySupplyMonitorService();

  const [filters, setFilters] = useState({
    startDate: null as string | null,
    endDate: null as string | null,
    dateRangeKey: "all",
    provinceId: activeFilters.provinceId ?? [],
    cityId: activeFilters.cityId ?? [],
    districtId: activeFilters.districtId ?? [],
    subdistrictId: activeFilters.subdistrictId ?? [],
    pointInterest: activeFilters.pointInterest ?? [],
    roadType: activeFilters.roadType ?? [],
  });

  const [filterOptions, setFilterOptions] = useState({
    provinceId: [] as SupplyMonitorProvinceResp[],
    cityId: [] as SupplyMonitorCityResp[],
    districtId: [] as SupplyMonitorDistrictResp[],
    subdistrictId: [] as SupplyMonitorSubdistrictResp[],
    pointInterest: [] as SupplyMonitorPointInterestResp[],
    roadType: [] as SupplyMonitorRoadTypeResp[],
  });

  type FilterOptionsKey = "provinceId" | "cityId" | "districtId" | "subdistrictId" | "pointInterest" | "roadType";

  const filteredCities = useMemo(() =>
    filters.provinceId.length > 0
        ? filterOptions.cityId.filter((c) => filters.provinceId.includes(c.parentId ?? ""))
        : filterOptions.cityId,
    [filters.provinceId, filterOptions.cityId]
  );

    const filteredDistricts = useMemo(() => {
    if (filters.cityId.length > 0) {
        return filterOptions.districtId.filter((d) =>
        filters.cityId.includes(d.parentId ?? "")
        );
    }
    if (filters.provinceId.length > 0) {
        const cityIdsInProvince = filteredCities.map((c) => c.id);
        return filterOptions.districtId.filter((d) =>
        cityIdsInProvince.includes(d.parentId ?? "")
        );
    }
    return filterOptions.districtId;
    }, [filters.cityId, filters.provinceId, filteredCities, filterOptions.districtId]);

    // const filteredSubdistrictIds = useMemo(() => {
    // if (filters.districtId.length > 0) {
    //     return filterOptions.subdistrictId.filter((s) =>
    //     filters.districtId.includes(s.parentId ?? "")
    //     );
    // }
    // if (filters.cityId.length > 0) {
    //     // Jika hanya city dipilih
    //     const districtIdsInCity = filteredDistricts.map((d) => d.id);
    //     return filterOptions.subdistrictId.filter((s) =>
    //     districtIdsInCity.includes(s.parentId ?? "")
    //     );
    // }
    // // if (filters.provinceId.length > 0) {
    // //     // Jika hanya province dipilih
    // //     const districtIdsInProvince = filteredDistricts.map((d) => d.id);
    // //     return filterOptions.subdistrictId.filter((s) =>
    // //     districtIdsInProvince.includes(s.parentId ?? "")
    // //     );
    // // }
    // // return filterOptions.subdistrictId;
    // }, [filters.districtId, filters.cityId, filters.provinceId, filteredDistricts]);

  const [searchQuery, setSearchQuery] = useState<Record<FilterOptionsKey, string>>({
    provinceId: "",
    cityId: "",
    districtId: "",
    subdistrictId: "",
    pointInterest: "",
    roadType: "",
  });

  const getFilteredOptions = (key: FilterOptionsKey) => {
    const query = searchQuery[key].toLowerCase();
    if (!query) return filterOptions[key];
    return filterOptions[key].filter((opt: any) =>
      opt.name.toLowerCase().includes(query)
    );
  };

  const [loading, setLoadingFilter] = useState(false);

  const toggleValue = (key: FilterOptionsKey, value: string) => {
    setFilters((prev) => {
        const list = prev[key] as string[];
        const exists = list.includes(value);
        const updated = exists
        ? list.filter((v) => v !== value)
        : [...list, value];

        if (key === "provinceId") {
        return { ...prev, provinceId: updated, cityId: [], districtId: [], subdistrictId: [] };
        }

        if (key === "cityId") {
        const selectedCities = updated;
        const parentIds = filterOptions.cityId
            .filter((c) => selectedCities.includes(c.id))
            .map((c) => c.parentId)
            .filter((id): id is string => !!id);
        const uniqueParentIds = [...new Set(parentIds)];

        return {
            ...prev,
            cityId: updated,
            provinceId: uniqueParentIds,
            districtId: [],
            subdistrictId: [],
        };
        }

        if (key === "districtId") {
        return { ...prev, districtId: updated, subdistrictId: [] };
        }

        return { ...prev, [key]: updated };
    });
    };

  const selectAll = (key: FilterOptionsKey) => {
    setFilters((prev) => ({
      ...prev,
      [key]:
        key === "pointInterest"
          ? filterOptions.pointInterest.map((o) => o.code)
          : filterOptions[key].map((o) => o.id),
    }));
  }

  const reset = (key: FilterOptionsKey) =>
    setFilters((prev) => ({ ...prev, [key]: [] }));

  const isSelected = (key: FilterOptionsKey, value: string) => {
    return (filters[key] as string[]).includes(value);
  };

  const fetchFilterConfig = async () => {
    const token = profile?.data.token;
    if (!token) return;
    setLoadingFilter(true);
    try {
      const res = await SupplyMonitorService.SupplyMonitorFilterConfig(token);
      setFilterOptions({
        provinceId: res.data?.province ?? [],
        cityId: res.data?.city ?? [],
        districtId: res.data?.district ?? [],
        subdistrictId: res.data?.subdistrict ?? [],
        pointInterest: res.data?.pointInterest ?? [],
        roadType: res.data?.roadType ?? [],
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingFilter(false);
    }
  };

  useEffect(() => {
    fetchFilterConfig();
    }, []);

    useEffect(() => {
        setFilters({
            startDate: null,
            endDate: null,
            dateRangeKey: "all",
            provinceId: activeFilters.provinceId ?? [],
            cityId: activeFilters.cityId ?? [],
            districtId: activeFilters.districtId ?? [],
            subdistrictId: activeFilters.subdistrictId ?? [],
            pointInterest: activeFilters.pointInterest ?? [],
            roadType: activeFilters.roadType ?? [],
        });
    }, []);

    const [showCustomDate, setShowCustomDate] = useState(false);
    const [customStart, setCustomStart] = useState<string | null>(null);
    const [customEnd, setCustomEnd] = useState<string | null>(null);

    const DATE_OPTIONS = [
        { key: "all",       label: "All Data" },
        { key: "today",     label: "Today" },
        { key: "yesterday", label: "Yesterday" },
        { key: "thisWeek",  label: "This Week" },
        { key: "lastWeek",  label: "Last Week" },
        { key: "thisMonth", label: "This Month" },
        { key: "lastMonth", label: "Last Month" },
        { key: "custom",    label: "Custom" },
    ];

    const toYMD = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;

    const handleDateSelect = (key: string) => {
        console.log("handleDateSelect called with key:", key);
        if (key === "custom") {
            setFilters((prev) => ({ ...prev, dateRangeKey: "custom" }));
            setShowCustomDate(true);
            return;
        }

        const now = new Date();
        let startDate: string | null = null;
        let endDate: string | null = null;

        if (key === "today") {
            startDate = toYMD(now); endDate = toYMD(now);
        } else if (key === "yesterday") {
            const y = new Date(now); y.setDate(y.getDate() - 1);
            startDate = toYMD(y); endDate = toYMD(y);
        } else if (key === "thisWeek") {
            const diff = (now.getDay() + 6) % 7;
            const mon = new Date(now); mon.setDate(now.getDate() - diff);
            const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
            startDate = toYMD(mon); endDate = toYMD(sun);
        } else if (key === "lastWeek") {
            const d = new Date(now); d.setDate(d.getDate() - 7);
            const diff = (d.getDay() + 6) % 7;
            const mon = new Date(d); mon.setDate(d.getDate() - diff);
            const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
            startDate = toYMD(mon); endDate = toYMD(sun);
        } else if (key === "thisMonth") {
            startDate = toYMD(new Date(now.getFullYear(), now.getMonth(), 1));
            endDate = toYMD(new Date(now.getFullYear(), now.getMonth() + 1, 0));
        } else if (key === "lastMonth") {
            startDate = toYMD(new Date(now.getFullYear(), now.getMonth() - 1, 1));
            endDate = toYMD(new Date(now.getFullYear(), now.getMonth(), 0));
        }

        console.log("Setting filters with:", { startDate, endDate, dateRangeKey: key });
        setFilters((prev) => ({ ...prev, startDate, endDate, dateRangeKey: key }));
    };

    const handleApplyCustomDate = () => {
        setFilters((prev) => ({ 
            ...prev, 
            startDate: customStart,
            endDate: customEnd 
        }));
        setShowCustomDate(false);
    };

  if (loading) {
    return (
        <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-4 text-center">
            <div className="spinner-border text-primary mx-auto" role="status" />
            <p className="mt-2 mb-0">Loading filter configuration...</p>
            </div>
        </div>
        </div>
    );
    }

    return (
        <div
            className="modal show d-block"
            tabIndex={-1}
            role="dialog"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={onClose}
        >
            <div
            className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
            role="document"
            onClick={(e) => e.stopPropagation()}
            >
            <div className="modal-content">

                {/* Header */}
                <div className="modal-header">
                <h5 className="modal-title fw-semibold">Filter</h5>
                <button type="button" className="btn-close" onClick={onClose} />
                </div>

                {/* Body */}
                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>

                    {/* Date Range — taruh sebelum Province */}
                    <div className="mb-4 pb-3 border-bottom">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-semibold mb-0">Date Range</h6>
                            <button
                            className="btn btn-link btn-sm p-0 text-secondary text-decoration-none"
                            onClick={() => setFilters((prev) => ({ ...prev, startDate: null, endDate: null, dateRangeKey: "all" }))}
                            >
                            Reset
                            </button>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {DATE_OPTIONS.map((o) => (
                                <button
                                    key={o.key}
                                    onClick={() => handleDateSelect(o.key)}
                                    className={`btn btn-sm ${filters.dateRangeKey === o.key ? "btn-primary" : "btn-outline-secondary"}`}
                                >
                                    {o.key === "custom" && filters.dateRangeKey === "custom" && filters.startDate
                                    ? `${filters.startDate} s/d ${filters.endDate ?? "Sekarang"}`
                                    : o.label}
                                </button>
                            ))}
                        </div>
                        </div>

                        {/* Custom Date mini-modal */}
                        {showCustomDate && (
                        <div
                            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1060 }}
                            onClick={() => setShowCustomDate(false)}
                        >
                            <div
                            className="card shadow p-4"
                            style={{ minWidth: 280 }}
                            onClick={(e) => e.stopPropagation()}
                            >
                            <h6 className="fw-semibold mb-3">Custom Date Range</h6>
                            <div className="mb-2">
                                <label className="form-label form-label-sm">Start Date</label>
                                <input
                                type="date"
                                className="form-control form-control-sm"
                                value={customStart ?? ""}
                                onChange={(e) => setCustomStart(e.target.value || null)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label form-label-sm">End Date</label>
                                <input
                                type="date"
                                className="form-control form-control-sm"
                                value={customEnd ?? ""}
                                min={customStart || undefined}
                                onChange={(e) => setCustomEnd(e.target.value || null)}
                                />
                            </div>
                            <div className="d-flex justify-content-end gap-2">
                                <button className="btn btn-sm btn-secondary" onClick={() => setShowCustomDate(false)}>
                                Cancel
                                </button>
                                <button className="btn btn-sm btn-primary" onClick={handleApplyCustomDate}>
                                Apply
                                </button>
                            </div>
                            </div>
                        </div>
                    )}

                {/* Province */}
                <div className="mb-4 pb-3 border-bottom">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="fw-semibold mb-0">Province</h6>
                    <div className="d-flex gap-2">
                        <button className="btn btn-link btn-sm p-0 text-primary text-decoration-none" onClick={() => selectAll("provinceId")}>
                        Select all
                        </button>
                        <button className="btn btn-link btn-sm p-0 text-secondary text-decoration-none" onClick={() => reset("provinceId")}>
                        Reset
                        </button>
                    </div>
                    </div>
                    <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search provinceId..."
                    value={searchQuery.provinceId}
                    onChange={(e) => setSearchQuery((prev) => ({ ...prev, provinceId: e.target.value }))}
                    />
                    <div className="d-flex flex-wrap gap-2">
                    {getFilteredOptions("provinceId").map((option) => (
                        <button
                        key={option.id}
                        onClick={() => toggleValue("provinceId", option.id)}
                        className={`btn btn-sm ${isSelected("provinceId", option.id) ? "btn-primary" : "btn-outline-secondary"}`}
                        >
                        {option.name}
                        </button>
                    ))}
                    </div>
                </div>

                {/* City */}
                {filteredCities.length > 0 && (
                    <div className="mb-4 pb-3 border-bottom">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-semibold mb-0">City</h6>
                        <div className="d-flex gap-2">
                        <button className="btn btn-link btn-sm p-0 text-primary text-decoration-none"
                            onClick={() => setFilters((prev) => ({ ...prev, cityId: filteredCities.map((o) => o.id), districtId: [], subdistrictId: [] }))}>
                            Select all
                        </button>
                        <button className="btn btn-link btn-sm p-0 text-secondary text-decoration-none"
                            onClick={() => setFilters((prev) => ({ ...prev, cityId: [], districtId: [], subdistrictId: [] }))}>
                            Reset
                        </button>
                        </div>
                    </div>
                    <input
                        type="text"
                        className="form-control form-control-sm mb-2"
                        placeholder="Search cityId..."
                        value={searchQuery.cityId}
                        onChange={(e) => setSearchQuery((prev) => ({ ...prev, cityId: e.target.value }))}
                    />
                    <div className="d-flex flex-wrap gap-2">
                        {filteredCities
                        .filter((c) => !searchQuery.cityId || c.name.toLowerCase().includes(searchQuery.cityId.toLowerCase()))
                        .map((option) => (
                            <button
                            key={option.id}
                            onClick={() => toggleValue("cityId", option.id)}
                            className={`btn btn-sm ${isSelected("cityId", option.id) ? "btn-primary" : "btn-outline-secondary"}`}
                            >
                            {option.name}
                            </button>
                        ))}
                    </div>
                    </div>
                )}

                {/* District */}
                {filteredDistricts.length > 0 && (
                    <div className="mb-4 pb-3 border-bottom">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-semibold mb-0">District</h6>
                        <div className="d-flex gap-2">
                        <button className="btn btn-link btn-sm p-0 text-primary text-decoration-none"
                            onClick={() => setFilters((prev) => ({ ...prev, districtId: filteredDistricts.map((o) => o.id), subdistrictId: [] }))}>
                            Select all
                        </button>
                        <button className="btn btn-link btn-sm p-0 text-secondary text-decoration-none"
                            onClick={() => setFilters((prev) => ({ ...prev, districtId: [], subdistrictId: [] }))}>
                            Reset
                        </button>
                        </div>
                    </div>
                    <input
                        type="text"
                        className="form-control form-control-sm mb-2"
                        placeholder="Search districtId..."
                        value={searchQuery.districtId}
                        onChange={(e) => setSearchQuery((prev) => ({ ...prev, districtId: e.target.value }))}
                    />
                    <div className="d-flex flex-wrap gap-2">
                        {filteredDistricts
                        .filter((d) => !searchQuery.districtId || d.name.toLowerCase().includes(searchQuery.districtId.toLowerCase()))
                        .map((option) => (
                            <button
                            key={option.id}
                            onClick={() => toggleValue("districtId", option.id)}
                            className={`btn btn-sm ${isSelected("districtId", option.id) ? "btn-primary" : "btn-outline-secondary"}`}
                            >
                            {option.name}
                            </button>
                        ))}
                    </div>
                    </div>
                )}

                {/* SubdistrictId */}
                {/* {filteredSubdistrictIds.length > 0 && (
                    <div className="mb-4 pb-3 border-bottom">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-semibold mb-0">SubdistrictId</h6>
                        <div className="d-flex gap-2">
                        <button className="btn btn-link btn-sm p-0 text-primary text-decoration-none"
                            onClick={() => setFilters((prev) => ({ ...prev, subdistrictId: filteredSubdistrictIds.map((o) => o.id) }))}>
                            Select all
                        </button>
                        <button className="btn btn-link btn-sm p-0 text-secondary text-decoration-none"
                            onClick={() => setFilters((prev) => ({ ...prev, subdistrictId: [] }))}>
                            Reset
                        </button>
                        </div>
                    </div>
                    <input
                        type="text"
                        className="form-control form-control-sm mb-2"
                        placeholder="Search subdistrictId..."
                        value={searchQuery.subdistrictId}
                        onChange={(e) => setSearchQuery((prev) => ({ ...prev, subdistrictId: e.target.value }))}
                    />
                    <div className="d-flex flex-wrap gap-2">
                        {filteredSubdistrictIds
                        .filter((s) => !searchQuery.subdistrictId || s.name.toLowerCase().includes(searchQuery.subdistrictId.toLowerCase()))
                        .map((option) => (
                            <button
                            key={option.id}
                            onClick={() => toggleValue("subdistrictId", option.id)}
                            className={`btn btn-sm ${isSelected("subdistrictId", option.id) ? "btn-primary" : "btn-outline-secondary"}`}
                            >
                            {option.name}
                            </button>
                        ))}
                    </div>
                    </div>
                )} */}

                {/* Point of Interest */}
                {getFilteredOptions("pointInterest").length > 0 && (
                    <div className="mb-4 pb-3 border-bottom">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-semibold mb-0">Point of Interest</h6>
                        <div className="d-flex gap-2">
                        <button className="btn btn-link btn-sm p-0 text-primary text-decoration-none" onClick={() => selectAll("pointInterest")}>
                            Select all
                        </button>
                        <button className="btn btn-link btn-sm p-0 text-secondary text-decoration-none" onClick={() => reset("pointInterest")}>
                            Reset
                        </button>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                        {getFilteredOptions("pointInterest").map((option) => (
                        <button
                            key={option.id}
                            onClick={() => toggleValue("pointInterest", option.id)}
                            className={`btn btn-sm ${isSelected("pointInterest", option.id) ? "btn-primary" : "btn-outline-secondary"}`}
                        >
                            {option.name}
                        </button>
                        ))}
                    </div>
                    </div>
                )}

                {/* Road Type */}
                {getFilteredOptions("roadType").length > 0 && (
                    <div className="mb-2">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-semibold mb-0">Road Type</h6>
                        <div className="d-flex gap-2">
                        <button className="btn btn-link btn-sm p-0 text-primary text-decoration-none" onClick={() => selectAll("roadType")}>
                            Select all
                        </button>
                        <button className="btn btn-link btn-sm p-0 text-secondary text-decoration-none" onClick={() => reset("roadType")}>
                            Reset
                        </button>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                        {filterOptions.roadType.map((option) => (
                        <button
                            key={option.id}
                            onClick={() => toggleValue("roadType", option.id)}
                            className={`btn btn-sm ${isSelected("roadType", option.id) ? "btn-primary" : "btn-outline-secondary"}`}
                        >
                            {option.name}
                        </button>
                        ))}
                    </div>
                    </div>
                )}

                </div>

                {/* Footer */}
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    <button
                        className="btn btn-primary"
                        onClick={() => {console.log("Applying filters:", filters); onApply(filters)}}
                    >
                        Apply Filters
                    </button>
                </div>

            </div>
            </div>
        </div>
    );
};

export default ModalFilterSupplyMonitor;